import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

function TrackDot({ status, color, label }) {
  const baseClasses = "w-3 h-3 rounded-full border-2 cursor-pointer transition-all";
  const colorMap = {
    amber: {
      not_started: 'border-amber-400 bg-transparent',
      in_progress: 'border-amber-400 bg-amber-400/50',
      completed: 'border-amber-400 bg-amber-400'
    }
  };
  const statusLabel = {
    not_started: 'Not Started',
    in_progress: 'In Progress',
    completed: 'Completed'
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={`${baseClasses} ${colorMap[color]?.[status] || colorMap[color]?.not_started}`} />
        </TooltipTrigger>
        <TooltipContent side="top" className="text-xs">
          <p>{label}: {statusLabel[status] || 'Not Started'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default function BalloonTrackIndicator({ issue, onClick }) {
  const t3 = issue.rock_track3_status || 'not_started';

  return (
    <div
      className="bg-sky-100 px-2 py-1 rounded-md flex items-center gap-1.5 border border-sky-500/30 cursor-pointer hover:bg-sky-200 transition-colors"
      onClick={onClick}
      title="Click to manage Balloon Operational Response"
    >
      <span className="text-sky-700 mr-1">TRACK</span>
      <TrackDot status={t3} color="amber" label="Operational Response" />
    </div>
  );
}